//@ts-check
import classNames from 'classnames';
import React, {PureComponent} from 'react';
import {node, func, object, string} from 'prop-types';
import {angleRight} from 'react-icons-kit/fa/angleRight';
import {omit} from 'ramda';
import Icon from '../../../components/Icon';
import styles from './Link.css';
import {preventDefault} from '../../../util';

/**
 * @typedef {Object} SidebarLinkProps
 * @prop {React.ReactNode} children
 * @prop {React.ReactNode} icon
 * @prop {String} [className]
 */

/**
 * @extends {PureComponent<SidebarLinkProps>}
 */
class SidebarLink extends PureComponent {
  static propTypes = {
    children: node.isRequired,
    icon: node.isRequired,
    className: string,
  };

  static childContextTypes = {
    parent: object,
    getDisabled: func,
    setDisabled: func,
  };

  constructor(props) {
    super(props);
    this.state = {disabled: false};
  }

  render() {
    const {className, children, icon} = this.props;
    return (
      <div
        className={classNames(styles.SidebarLink, className)}
        onMouseDown={preventDefault}
        {...omit(['children', 'icon', 'className'], this.props)}
      >
        {icon}
        <div className={styles.content}>{children}</div>
        <Icon icon={angleRight} size="25" />
      </div>
    );
  }
}

export default SidebarLink;
